/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Organize_2Inputs */

const en_pc_tut_organize_2 = /** @type {(inputs: Pc_Tut_Organize_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select pages: click one, ⌘-click to add pages, ⇧-click to select a range.`)
};

const zh_pc_tut_organize_2 = /** @type {(inputs: Pc_Tut_Organize_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择页面：单击选一页，⌘+点击追加，⇧+点击选择连续范围。`)
};

/**
* | output |
* | --- |
* | "Select pages: click one, ⌘-click to add pages, ⇧-click to select a range." |
*
* @param {Pc_Tut_Organize_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_organize_2 = /** @type {((inputs?: Pc_Tut_Organize_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Organize_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_organize_2(inputs)
	return zh_pc_tut_organize_2(inputs)
});
export { pc_tut_organize_2 as "pc.tut.organize.2" }